import { SmileyFace } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'

const AllClear = () => {
  return (
    <Section.ActionItemsMessage>
      <SVGWrapper svg={SmileyFace} fill='#3A4D57' size='large' />
      <Section.ActionItemMessageText>All clear!</Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}

export default AllClear
